export function isTracingEnabled(actionName?: string): boolean {
    const allowedActionsForTracing = [
        'startupdata',
        'getconversationitems',
        'getitem',
        'moveitem',
        'getowauserconfiguration',
    ];
    if (actionName && allowedActionsForTracing.includes(actionName.toLowerCase())) {
        return true;
    }
    return false;
}
